import { IconType } from "@/app/components/icons/icon.type";

const PhotoshopFileIcon = ({ style, className }: IconType) => (
  <svg
    style={style}
    className={className}
    width="33"
    height="38"
    viewBox="0 0 33 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_466_30229)">
      <rect
        x="0.620117"
        width="32"
        height="38"
        rx="6"
        fill="#3451B2"
        stroke="#01012E"
        strokeOpacity="0.134"
        strokeWidth="0.59375"
      />
      <g filter="url(#filter0_ddd_466_30229)">
        <path
          d="M33.2401 11.62L21.6201 0C21.6201 5.31 21.6201 7.97 23.2201 9.69C23.3201 9.8 23.4301 9.92 23.5501 10.02C25.2601 11.61 27.9301 11.62 33.2401 11.62Z"
          fill="#000418"
          fillOpacity="0.506"
          shapeRendering="crispEdges"
        />
      </g>
      <path
        d="M21.6202 0.000117302L33.2402 11.6201C33.2402 6.31012 33.2402 3.65012 31.6402 1.93012C31.5402 1.82012 31.4302 1.70012 31.3102 1.60012C29.6002 0.0101166 26.9302 0.000117302 21.6202 0.000117302Z"
        fill="white"
      />
      <path
        d="M8.04217 25.5V15.3182H12.0592C12.8315 15.3182 13.4894 15.4657 14.0329 15.7607C14.5765 16.0523 14.9908 16.4583 15.2758 16.9787C15.5642 17.4957 15.7084 18.0923 15.7084 18.7685C15.7084 19.4446 15.5625 20.0412 15.2709 20.5582C14.9792 21.0753 14.5566 21.478 14.0031 21.7663C13.4529 22.0547 12.7867 22.1989 12.0045 22.1989H9.44416V20.4737H11.6565C12.0708 20.4737 12.4122 20.4025 12.6807 20.2599C12.9524 20.1141 13.1546 19.9136 13.2872 19.6584C13.4231 19.3999 13.491 19.1032 13.491 18.7685C13.491 18.4304 13.4231 18.1354 13.2872 17.8835C13.1546 17.6283 12.9524 17.4311 12.6807 17.2919C12.4089 17.1494 12.0642 17.0781 11.6466 17.0781H10.1949V25.5H8.04217ZM23.4205 20.0412L21.4816 20.1605C21.4485 19.9948 21.3772 19.8456 21.2678 19.7131C21.1585 19.5772 21.0143 19.4695 20.8353 19.3899C20.6597 19.3071 20.4492 19.2656 20.2039 19.2656C19.8758 19.2656 19.599 19.3352 19.3737 19.4744C19.1483 19.6103 19.0356 19.7926 19.0356 20.0213C19.0356 20.2036 19.1085 20.3577 19.2544 20.4837C19.4002 20.6096 19.6504 20.7107 20.0051 20.7869L21.3872 21.0653C22.1296 21.2178 22.6831 21.4631 23.0477 21.8011C23.4123 22.1392 23.5945 22.5833 23.5945 23.1335C23.5945 23.634 23.4471 24.0732 23.1521 24.451C22.8604 24.8288 22.4594 25.1238 21.949 25.3359C21.4419 25.5447 20.8569 25.6491 20.194 25.6491C19.1831 25.6491 18.3777 25.4387 17.7778 25.0178C17.1812 24.5935 16.8315 24.0168 16.7288 23.2876L18.8119 23.1783C18.8749 23.4865 19.0273 23.7218 19.2693 23.8842C19.5112 24.0433 19.8211 24.1229 20.199 24.1229C20.5702 24.1229 20.8685 24.0516 21.0938 23.9091C21.3225 23.7633 21.4385 23.576 21.4419 23.3473C21.4385 23.1551 21.3573 22.9976 21.1982 22.875C21.0392 22.7491 20.7939 22.6529 20.4624 22.5866L19.14 22.3232C18.3943 22.174 17.8391 21.9155 17.4745 21.5476C17.1133 21.1797 16.9326 20.7107 16.9326 20.1406C16.9326 19.6501 17.0652 19.2275 17.3303 18.8729C17.5988 18.5182 17.975 18.2448 18.4589 18.0526C18.9461 17.8603 19.5162 17.7642 20.1691 17.7642C21.1336 17.7642 21.8926 17.968 22.4461 18.3757C23.0029 18.7834 23.3277 19.3385 23.4205 20.0412Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_ddd_466_30229"
        x="17.6201"
        y="-3"
        width="19.6201"
        height="19.6201"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0 0 0 0.051 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_466_30229"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="1"
          operator="erode"
          in="SourceAlpha"
          result="effect2_dropShadow_466_30229"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0 0 0 0.051 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_466_30229"
          result="effect2_dropShadow_466_30229"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.055 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_466_30229"
          result="effect3_dropShadow_466_30229"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow_466_30229"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_466_30229">
        <path
          d="M0.620117 11.7C0.620117 6.33443 0.620117 3.65165 2.21418 1.9272C2.32082 1.81183 2.43195 1.7007 2.54731 1.59406C4.27176 0 6.95455 0 12.3201 0H20.9201C26.2857 0 28.9685 0 30.6929 1.59406C30.8083 1.7007 30.9194 1.81183 31.0261 1.9272C32.6201 3.65165 32.6201 6.33443 32.6201 11.7V26.3C32.6201 31.6656 32.6201 34.3484 31.0261 36.0728C30.9194 36.1882 30.8083 36.2993 30.6929 36.4059C28.9685 38 26.2857 38 20.9201 38H12.3201C6.95455 38 4.27176 38 2.54731 36.4059C2.43195 36.2993 2.32082 36.1882 2.21418 36.0728C0.620117 34.3484 0.620117 31.6656 0.620117 26.3V11.7Z"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);

export default PhotoshopFileIcon;
